export const RNPermissionsAndroid = {
  request: () => {},
  PERMISSIONS: { CAMERA: '' },
  RESULTS: { GRANTED: '' },
};
